import React from 'react';

const OfferPriceDropdown = ({ offerPriceInfo }) => {
	const renderTableBody = () => {
		return offerPriceInfo?.map((item, idx) => {
			return (
				<tr key={idx}>
					<td>{item?.brandResponse?.name}</td>
					<td>
						<div className="d-flex align-items-center">
							<span className="mr-1">${item?.offerPrice.toFixed(2)}</span>{' '}
							<span>({item?.percentage}%)</span>
						</div>
					</td>
				</tr>
			);
		});
	};

	return (
		<div className="offer-price-dropdown shadow-24dp">
			<h3 className="semibold-14">Offer Price </h3>
			<div className="offer-price-table scroll-y-label">
				<table className="table with-border height-sm">
					<thead>
						<tr>
							<th>Brand</th>
							<th>Price</th>
						</tr>
					</thead>
					<tbody>{renderTableBody()}</tbody>
				</table>
			</div>
		</div>
	);
};

export default OfferPriceDropdown;
